/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscodelabel2Inputs */

const en_partnerscodelabel2 = /** @type {(inputs: Partnerscodelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code in the link (optional)`)
};

const de_partnerscodelabel2 = /** @type {(inputs: Partnerscodelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kürzel im Link (optional)`)
};

/**
* | output |
* | --- |
* | "Code in the link (optional)" |
*
* @param {Partnerscodelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscodelabel2 = /** @type {((inputs?: Partnerscodelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscodelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscodelabel2(inputs)
	return de_partnerscodelabel2(inputs)
});
export { partnerscodelabel2 as "partnersCodeLabel" }